import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TagType } from 'carbon-components-angular/tag/tag.component';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ContainedListKind, NumberChange, PaginationModel } from 'carbon-components-angular';
import { SyncService } from '../../sync.service';
import { HttpService } from '../../http.service';
import { NotificationType } from 'carbon-components-angular/notification/notification-content.interface';

@Component({
	selector: 'file-data',
	templateUrl: './file-data.component.html',
	styleUrls: ['./file-data.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		]),
		trigger('fadeInLong', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('1000ms ease-in', style({ opacity: 1 }))
			]),
		]),
	]
})

export class FileDataComponent implements OnInit {

	fieldValueInvalid = false;
	fieldValueInvalidText = 'Hello here';

	addAssetNameInvalid = false;
	addAssetnameInvalidText = 'Asset name is required.';

	accordianIndex = -1;
	indexOfAssetToRemove = -1;
	showAssetName = false;

	constructor(
		private cdr: ChangeDetectorRef,
		private http: HttpClient,
		private httpService: HttpService,
		private syncService: SyncService,
	) {}

	numLLMs = 4;

	hoveringOverItem: any;

	displayAssetIndex = 999;
	expandPortfolioAsset = false;

	fileId = '';

	extractedData: any;
	currentFileData: any;
	page: string = 'file-data';

	addAssetName: any;
	fieldValue: any;
	fieldPage: any;
	fieldName: any;
	fieldOrg: any;
	checked = false;
	validTagTypes: TagType[] = ['gray', 'gray', 'gray', 'teal', 'green'];

	polygonUrl: string = '';
	showSpinner = false;
	highlightedPage = -1;
	highlightedPageData = '';

	addAssetModalOpen = false;
	removeAssetModalOpen = false;
	addAssetAtIndex = 0;

	showErrorNotification = false;

	currentPageInView = 1;
	listenToScroll: boolean = true;
	paginationModel = new PaginationModel();

	protected readonly Object = Object;
	protected readonly Number = Number;
	editFieldModalOpen = false;
	pageNumInvalid: any;
	pageNumInvalidText: any;

	ngOnInit(): void {

		this.polygonUrl = environment.polygonUrl;
		this.showSpinner = true;
		this.paginationModel.pageLength = 1;
		this.paginationModel.currentPage = 1;

		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}

		this.syncService.page$.subscribe((page) => {
			this.page = page;
			if (this.page === 'file-data') {
				this.bindScroll();
			}
		});

		this.syncService.fileData$.subscribe((data) => {
			if (data) {
				this.currentFileData = data;
				this.extractedData = this.currentFileData['Extracted Data'];
				// alert(JSON.stringify(this.extractedData));
				this.paginationModel.totalDataLength = this.currentFileData['Pages'].length;
			}
		});

		this.syncService.fileId.subscribe((data) => {
			if (data) {
				this.fileId = data;
			}
		});

		this.httpService.wakeUpServer();
		this.showSpinner = false;
	}

	onDataScroll(event: Event): void {
		const expandContainer = document.getElementById('expand-container');
		if (expandContainer) {
		  const distanceToTop = expandContainer.getBoundingClientRect().top;
		  this.showAssetName = distanceToTop <= 120;
		}
	}

	onPDFScroll(event: Event): void {
		const container = document.getElementById('pdf-container');
		if (!container || !this.listenToScroll) {
			return;
		}
		const containerTop = container.scrollTop;
		const containerBottom = containerTop + container.clientHeight;

		// Find all img elements inside the container
		const imgElements = Array.from(container.querySelectorAll('img'));

		imgElements.forEach((img, index) => {
			const imgTop = img.offsetTop;
			const imgBottom = imgTop + img.clientHeight;

			// Calculate if the img element is at least 50% visible
			const isHalfVisible = imgTop < containerBottom && imgBottom > containerTop &&
								  (Math.min(imgBottom, containerBottom) - Math.max(imgTop, containerTop)) >= container.clientHeight / 2;

			if (isHalfVisible) {
				this.currentPageInView = index;
				this.paginationModel.currentPage = this.currentPageInView + 1;
				return; // Stop loop once the first visible page is found
			}
		});
	}

	getListTitle(fundData: any) {
		const assetNameKey = Object.keys(fundData)[0];
		if (assetNameKey.startsWith('00')) {
			return 'Fund Financials'
		} else if (assetNameKey.startsWith('05')) {
			return 'Seller LP Position'
		} else if (assetNameKey.startsWith('10')) {
			return 'Fund Terms'
		}
		return 'Other Financials'
	}


	enteringItem(key: any) {
		this.hoveringOverItem = key;
	}

	isPeriodicValue(key: string, value: string){
		return [
			'Portfolio Asset Revenue',
			'Portfolio Asset EBITDA',
			'Portfolio Asset Net Income',
			'Portfolio Asset Cash',
			'Portfolio Asset Debt'
		].includes(key.slice(4)) && value.includes('-');
	}

	getValue(valueObject: any) {
		let index = valueObject['Index'];
		if (!('Index' in valueObject)) {
			index = 0;
		}
		if (valueObject['Edited'] && index === 0) {
			return valueObject['Value'];
		}
		return valueObject['Responses'][index]['Value'];
	}

	browseMoreAnswers(actionData: any) {
		let responseIndex;
		this.fieldName = actionData[0];
		this.fieldValue = actionData[1]['Value'];
		this.checked = !actionData[1]['Checked'];
		if (this.fieldName.includes('|')) {
			const [editOrg, editField] = this.fieldName.split('|');
			this.fieldOrg = editOrg;
			this.fieldName = editField;
			if (this.fieldOrg === 'Fund') {
				if ('Index' in this.extractedData[this.fieldOrg][this.fieldName]) {
					responseIndex = (this.extractedData[this.fieldOrg][this.fieldName]['Index'] + 1) % (this.numLLMs + 1);
				} else {
					responseIndex = 1;
				}
				this.extractedData[this.fieldOrg][this.fieldName]['Index'] = responseIndex;
				this.extractedData[this.fieldOrg][this.fieldName]['Value'] = this.extractedData[this.fieldOrg][this.fieldName]['Responses'][responseIndex]['Value'];
				this.extractedData[this.fieldOrg][this.fieldName]['Page'] = this.extractedData[this.fieldOrg][this.fieldName]['Responses'][responseIndex]['Page'];
				this.extractedData[this.fieldOrg][this.fieldName]['Edited'] = false;
				this.extractedData[this.fieldOrg][this.fieldName]['Checked'] = false;
			} else {
				this.extractedData['Portfolio Assets'].forEach((company: any, index: number) => {
					if (company['000-Asset Name']['Value'] === this.fieldOrg) {
						if ('Index' in company[this.fieldName]) {
							responseIndex = (company[this.fieldName]['Index'] + 1) % (this.numLLMs + 1);
						} else {
							responseIndex = 1;
						}
						this.extractedData['Portfolio Assets'][index][this.fieldName]['Index'] = responseIndex;
						this.extractedData['Portfolio Assets'][index][this.fieldName]['Value'] = this.extractedData['Portfolio Assets'][index][this.fieldName]['Responses'][responseIndex]['Value'];
						this.extractedData['Portfolio Assets'][index][this.fieldName]['Page'] = this.extractedData['Portfolio Assets'][index][this.fieldName]['Responses'][responseIndex]['Page'];
						this.extractedData['Portfolio Assets'][index][this.fieldName]['Edited'] = false;
						this.extractedData['Portfolio Assets'][index][this.fieldName]['Checked'] = false;
					}
				});
			}
		} else {
			if ('Index' in this.extractedData[this.fieldName]) {
				responseIndex = (this.extractedData[this.fieldName]['Index'] + 1) % (this.numLLMs + 1);
			} else {
				responseIndex = 1;
			}
			this.extractedData[this.fieldName]['Index'] = responseIndex;
			this.extractedData[this.fieldName]['Value'] = this.extractedData[this.fieldName]['Responses'][responseIndex]['Value'];
			this.extractedData[this.fieldName]['Page'] = this.extractedData[this.fieldName]['Responses'][responseIndex]['Page'];
			this.extractedData[this.fieldName]['Edited'] = false;
			this.extractedData[this.fieldName]['Checked'] = false;
		}
		this.syncService.updateFileData(this.currentFileData);
		this.cdr.detectChanges();
	}

	editAssetname(index: number) {
		this.editExtractedValue([this.extractedData['Portfolio Assets'][index]['000-Asset Name']['Value'] + '|' + '000-Asset Name', this.extractedData['Portfolio Assets'][index]['000-Asset Name']])
	}

	editExtractedValue(actionData: any) {

		this.fieldName = actionData[0];
		if (actionData[1]['Edited']) {
			this.fieldValue = actionData[1]['Value'];
			this.fieldPage = actionData[1]['Page'] + 1;
		} else {
			let index = actionData[1]['Index'];
			if (index) {
				this.fieldValue = actionData[1]['Responses'][index]['Value'];
				this.fieldPage = actionData[1]['Responses'][index]['Page'] + 1;
			} else {
				this.fieldValue = actionData[1]['Responses'][0]['Value'];
				this.fieldPage = actionData[1]['Responses'][0]['Page'] + 1;
			}
		}

		if (this.fieldName.includes('|')) {
			const [editOrganization, editField] = this.fieldName.split('|');
			this.fieldOrg = editOrganization;
			this.fieldName = editField;
		} else {
			this.fieldOrg = '';
		}
		this.enteringItem(null)
		this.editFieldModalOpen = true;
	}

	confirmAsAccurate(actionData: any) {
		this.fieldName = actionData[0];
		this.fieldValue = actionData[1]['Value'];
		this.checked = !actionData[1]['Checked'];
		if (this.fieldName.includes('|')) {
			const [editOrganization, editField] = this.fieldName.split('|');
			this.fieldOrg = editOrganization;
			this.fieldName = editField;
			if (this.fieldOrg === 'Fund') {
				this.extractedData[this.fieldOrg][this.fieldName]['Checked'] = this.checked;
			} else {
				this.extractedData['Portfolio Assets'].forEach((company: any) => {
					if (company['000-Asset Name']['Value'] === this.fieldOrg) {
						company[this.fieldName]['Checked'] = this.checked;
					}
				});
			}
		} else {
			this.extractedData[this.fieldName]['Checked'] = this.checked;
		}
		this.currentFileData['Extracted Data'] = this.extractedData;
		this.syncService.updateFileData(this.currentFileData);
	}

	getTagType(keyData: any) {
		if (keyData['Edited'] && keyData['Index'] === 0) {
			return 'green';
		}
		if (keyData['Index'] === undefined || keyData['Index'] === 0) {
			return this.validTagTypes[keyData['Votes']];
		}
		return 'gray';
	}

	getTagText(keyData: any) {
		if (keyData['Edited'] && keyData['Index'] === 0) {
			return 'Ed';
		}
		if (keyData['Index'] === undefined || keyData['Index'] === 0) {
			return keyData['Votes'].toString() + '/' + this.numLLMs.toString();
		} else {
			return '#' + keyData['Index'];
		}
	}

	async renderBoundingBox(event: any, entity: string, field: string, fieldData: any) {
		const page = fieldData['Page'];
		const value = fieldData['Value'];
		if (!event || page === -1 || value === 'N/A') {
			return;
		}

		this.showSpinner = true;
		this.highlightedPage = page;
		const formData: FormData = new FormData();
		if ('Edited' in fieldData || !('Polygons' in fieldData['Responses'][0])) {
			formData.append('Field', field);
			formData.append('Entity', entity);
			formData.append('Value', value);
			// @ts-ignore
			formData.append('Polygons Document', this.currentFileData['Pages'][page]['Polygons Document']);

		} else {
			let index = fieldData['Index'];
			if (index === undefined) {
				index = 0;
			}
			const polygonCoordinates = fieldData['Responses'][index]['Polygons'];
			formData.append('Page URL', this.currentFileData['Pages'][page]['Page URL']);
			formData.append('Polygons', polygonCoordinates);
		}

		const headers = new HttpHeaders();
		headers.append('Content-Type', 'multipart/form-data');

		this.http.post(this.polygonUrl, formData, { headers, responseType: 'json' })
		.subscribe((response: any) => {
			const base64Image = response['Image'];
			const offsetValue = response['Offset'];
			this.showSpinner = false;
			this.bindScroll();
			if (offsetValue === -1) {
				this.highlightedPage = -1;
				if (offsetValue === -1) {
					this.syncService.updateNotifyValueNotFound(true);
					setTimeout(() => {
						this.syncService.updateNotifyValueNotFound(false);
					}, 5000);
				}
			} else {
				this.highlightedPageData = 'data:image/png;base64,' + base64Image;
			}
			setTimeout(() => {
				this.paginationModel.currentPage = page + 1;
				this.scrollToPageWithOffset(page, offsetValue);
			}, 187.5);
		}, (error: any) => {
			console.error('Error occurred while rendering the page:', error);
			this.showSpinner = false;
			this.bindScroll();
			this.showErrorNotification = true;
			setTimeout(() => {
				this.showErrorNotification = false;
			}, 5000);
			return;
		});
	}

	bindScroll() {
		setTimeout(() => {
			const dataContainer = document.getElementById('data-panel');
			if (this.page === 'file-data' && dataContainer) {
				dataContainer.addEventListener('scroll', this.onDataScroll.bind(this));
			}
			const pdfContainer = document.getElementById('pdf-container');
			if (this.page === 'file-data' && pdfContainer) {
				pdfContainer.addEventListener('scroll', this.onPDFScroll.bind(this));
			}
		}, 100);
	}

	doNothing(event: any) {
		try {
			event.stopPropagation();
		} catch (error) {}
	}

	scrollToPageWithOffset(page: number, offset: number = 0) {

		const element = document.getElementById(`page-${page}`);
		const container = document.getElementById('pdf-container');

		if (element && container) {
			if (offset === -1) {
				const elementPosition = element.getBoundingClientRect().top - container.getBoundingClientRect().top;
				container.scrollTo({
					top: elementPosition + 50,
					behavior: 'auto'
				});
			} else {
				const elementPosition = element.getBoundingClientRect().top - container.getBoundingClientRect().top;
				const viewportHeight = window.innerHeight;
				offset = offset * element.clientHeight;
				const scrollToPosition = elementPosition + offset + container.getBoundingClientRect().top - viewportHeight / 2;
				container.scrollTo({
					top: scrollToPosition + 50,
					behavior: 'auto'
				});
			}
		}

	}

	scrollToPage($event: number) {
		this.listenToScroll = false;
		const container = document.getElementById('pdf-container');
		const targetElement = document.getElementById(`page-${$event - 1}`);
		// @ts-ignore
		// const targetPosition = targetElement.offsetTop - container.offsetTop + 40;
		const targetPosition = targetElement.offsetTop - container.offsetTop;

		// @ts-ignore
		targetElement.scrollIntoView({
			// @ts-ignore
			top: targetPosition,
		});

		setTimeout(() => {
			this.listenToScroll = true;
			this.paginationModel.currentPage = $event;
		}, 750);
	}

	onKeyUpEditField($event: any) {
		this.fieldValue = ($event.target as HTMLInputElement).value;
		this.validateFieldValue();
	}

	validateFieldValue() {
		this.fieldValueInvalid = false;
		if (!this.fieldValue) {
			this.fieldValueInvalid = true;
			this.fieldValueInvalidText = 'Field value cannot be empty.';
		}
	}

	onSaveClick() {
		if (this.fieldOrg === 'Fund') {
			this.currentFileData['Extracted Data']['Fund'][this.fieldName]['Value'] = this.fieldValue;
			this.currentFileData['Extracted Data']['Fund'][this.fieldName]['Page'] = this.fieldPage - 1;
			this.currentFileData['Extracted Data']['Fund'][this.fieldName]['Checked'] = true;
			this.currentFileData['Extracted Data']['Fund'][this.fieldName]['Edited'] = true;
			this.currentFileData['Extracted Data'][this.fieldOrg][this.fieldName]['Index'] = 0;
		} else if (this.fieldOrg) {
			this.currentFileData['Extracted Data']['Portfolio Assets'].forEach((asset: any) => {
				if (asset['000-Asset Name']['Value'] === this.fieldOrg) {
					asset[this.fieldName]['Value'] = this.fieldValue;
					asset[this.fieldName]['Page'] = this.fieldPage - 1;
					asset[this.fieldName]['Checked'] = true;
					asset[this.fieldName]['Edited'] = true;
					asset[this.fieldName]['Index'] = 0;
				}
			});
		} else {
			this.currentFileData['Extracted Data'][this.fieldName]['Value'] = this.fieldValue;
			this.currentFileData['Extracted Data'][this.fieldName]['Page'] = this.fieldPage - 1;
			this.currentFileData['Extracted Data'][this.fieldName]['Checked'] = true;
			this.currentFileData['Extracted Data'][this.fieldName]['Edited'] = true;
			this.currentFileData['Extracted Data'][this.fieldName]['Index'] = 0;
		}
		this.syncService.updateFileData(this.currentFileData);
		this.syncService.updateNotification('success', 'Your changes have been saved.', "Fields marked with 'Ed' indicate an edit has been made.");
		this.editFieldModalOpen = false;
	}

	onCloseModal() {
		this.editFieldModalOpen = false;
	}

	updatePageNum($event: NumberChange) {
		console.log('updatePageNum', $event);
	}

	changeDisplayAssetIndex(i: number, $event: any) {
		$event.stopPropagation();
		if (this.displayAssetIndex === i) {
			// alert(this.expandPortfolioAsset)
			this.expandPortfolioAsset = !this.expandPortfolioAsset;
			// this.expandPortfolioAsset = true;
		} else {
			this.displayAssetIndex = i;
			this.expandPortfolioAsset = true;
		}
	}

	addAssetAbove(index: any) {
		this.addAssetAtIndex = index;
		this.addAssetModalOpen = true;
	}

	addAssetBellow(index: any) {
		this.addAssetAtIndex = index + 1;
		this.addAssetModalOpen = true;
	}

	onSaveAddAsset() {
		if (!this.addAssetName) {
			this.addAssetNameInvalid = true;
			return
		}
		const formData: FormData = new FormData();
		formData.append('Files Document', this.fileId);
		formData.append('Asset Name', this.addAssetName);
		this.addAssetModalOpen = false;
		this.syncService.updateShowSpinner(true);
		this.addAssetName = '';
		this.http.post(environment.addAssetUrl, formData).toPromise().then(response => {
			this.currentFileData['Extracted Data']['Portfolio Assets'].splice(this.addAssetAtIndex, 0, response);
			this.syncService.updateFileData(this.currentFileData);
			this.syncService.updateShowSpinner(false);
			this.syncService.updateNotification('success', `Asset ${this.addAssetName} added successfully.`, 'Thank you for your patience.')
			// this.changeDisplayAndScroll(this.addAssetAtIndex);
			this.displayAssetIndex = this.addAssetAtIndex;
			this.expandPortfolioAsset = true;
			this.cdr.detectChanges();
			setTimeout(() => {
				this.scrollToAsset(this.displayAssetIndex - 1);
			}, 125)
		})
	}

	onClickRemoveAsset(index: any) {
		this.indexOfAssetToRemove = index;
		this.removeAssetModalOpen = true
	}

	confirmDeleteAsset() {
		this.currentFileData['Extracted Data']['Portfolio Assets'].splice(this.indexOfAssetToRemove, 1);
		this.syncService.updateFileData(this.currentFileData);
		this.removeAssetModalOpen = false;
		this.expandPortfolioAsset = false;
	}

	protected readonly ContainedListKind = ContainedListKind;

	scrollToAsset(index: number) {
		this.cdr.detectChanges();
		setTimeout(() => {
			const assetTop = document.getElementById('Asset ' + index.toString());
			if (assetTop) {
				assetTop.scrollIntoView({
					behavior: 'smooth'
				})
			}
		}, 126);
	}

	protected readonly Array = Array;

	changeDisplayAssetAndScrollBottom(i: number, $event: void) {
		this.changeDisplayAssetIndex(this.displayAssetIndex + 1 + i, $event);
		this.scrollToAsset(this.displayAssetIndex);
	}

	onKeyUpAddAssetName($event: KeyboardEvent) {
		this.addAssetName = ($event.target as HTMLInputElement).value;
		this.addAssetNameInvalid = this.addAssetName.length === 0;
	}
}
